// src/components/Listener/DashboardToastListener.js
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const DashboardToastListener = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // Only proceed if the path starts with /dashboard
        if (!location.pathname.startsWith("/dashboard")) return;

        const params = new URLSearchParams(location.search);
        const msg = params.get("msg");
        const type = params.get("type") || "default";

        // Only proceed if there is a message
        if (!msg) return;

        const isMobile = window.innerWidth <= 768;

        // Define toast options
        const toastOptions = {
            containerId: "dashboard-toast", // Target this specific container
            position: isMobile ? "bottom-center" : "top-right", // Conditional position
            autoClose: isMobile ? 3000 : 4000, // Adjust autoClose for mobile if needed
            hideProgressBar: isMobile, // Hide progress bar on mobile
            closeOnClick: true,
            pauseOnHover: !isMobile,
            draggable: !isMobile,
            theme: isMobile ? "dark" : "light", // Optional: different theme for mobile
        };

        // Show the toast
        switch (type) {
            case "success":
                toast.success(msg, toastOptions);
                break;
            case "error":
                toast.error(msg, toastOptions);
                break;
            case "info":
                toast.info(msg, toastOptions);
                break;
            case "warning":
                toast.warn(msg, toastOptions); // Changed from toast.warning to toast.warn
                break;
            default:
                toast(msg, toastOptions);
        }

        // Clean up URL parameters after showing the toast
        params.delete("msg");
        params.delete("type");
        navigate(location.pathname + (params.toString() ? `?${params}` : ""), { replace: true });

    }, [location, navigate]); // Rerun effect when location or navigate changes

    // Render the specific container for dashboard toasts
    // enableMultiContainer allows this alongside other containers
    return (
        <>
            {/* Optional: Add mobile-specific styles if needed, similar to GlobalToastListener */}
            <style>
                {`
                .Toastify__toast-container--bottom-center {
                    bottom: 60px !important; /* Adjust if needed */
                }
                @media (max-width: 768px) {
                    /* Reuse styles from GlobalToastListener for consistency */
                    .Toastify__toast-container[data-container-id="dashboard-toast"] .Toastify__toast {
                        border-radius: 25px !important;
                        min-height: 40px !important;
                        max-width: 280px !important;
                        margin: 0 auto !important;
                        padding: 8px 16px !important;
                        background-color: rgba(50, 50, 50, 0.95) !important;
                        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3) !important;
                        font-family: 'Roboto', sans-serif !important;
                        font-size: 14px !important;
                        color: white !important;
                        text-align: center !important;
                    }
                    .Toastify__toast-container[data-container-id="dashboard-toast"] .Toastify__toast-body {
                        padding: 0 !important;
                        font-weight: 400 !important;
                    }
                    .Toastify__toast-container[data-container-id="dashboard-toast"] .Toastify__close-button {
                        display: none !important;
                    }
                }
                `}
            </style>
            <ToastContainer enableMultiContainer containerId="dashboard-toast" />
        </>
    );
};

export default DashboardToastListener;